import styled from 'styled-components';

export const ProductNotFoundChip = styled.div`
  padding: 1px 8px;
  background: #debeb8;
  color: #8e291a;
  font-size: 14px;

  border-radius: 80px;
  width: fit-content;
`;

export const DeleteIcon = styled.div`
  display: flex;
  justify-content: center;
`;
